import { render, staticRenderFns } from "./SaveSearchInput.vue?vue&type=template&id=ba125510&scoped=true&"
import script from "./SaveSearchInput.vue?vue&type=script&lang=js&"
export * from "./SaveSearchInput.vue?vue&type=script&lang=js&"
import style0 from "./SaveSearchInput.vue?vue&type=style&index=0&id=ba125510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba125510",
  null
  
)

export default component.exports